/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  dummy: 'dummy_cadd149b',
};

export = styles;

loadStyles([{"rawString":".dummy_cadd149b{background:#00f}"}]);
/* tslint:enable */